<template>
  <v-snackbar
    id="app-notification"
    style="margin-bottom:15px;"
    v-model="snackBarPayload.show"
    :color="snackBarPayload.color"
    :timeout="snackBarPayload.timeout"
    top
    right
    vertical
  >
    <p style="margin:0;font-size:15px;">{{$t(snackBarPayload.message)}}</p>
    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        class="mt-0"
        text
        @click="snackBarPayload.show = false"
      >{{$t('Закрыть')}}</v-btn>
    </template>
  </v-snackbar>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import baseModule from "@/store/base.module";

@Component
export default class extends Vue {
  get snackBarPayload() {
    return baseModule.snackBarPayload;
  }
}
</script>